import { render, staticRenderFns } from "./LoadingRelative.vue?vue&type=template&id=125b7a61&"
import script from "./LoadingRelative.vue?vue&type=script&lang=js&"
export * from "./LoadingRelative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports